enum CentralBankPaymentStatus {
  NOT_PROCESSED = 0,
  PROCESSED_WITH_ERRORS = 1,
  PROCESSED_OK = 2,
  NOT_MATCHED = 3,
  DIFFERENT_AMOUNT = 4,
  PIM_TO_BE_MATCHED = 5,
  PIM_MATCHED = 6,
  POSSIBLE_DUPLICATE = 8,
  NOT_APPLICABLE = 9,
}

export default CentralBankPaymentStatus;
